<template>
  <v-dialog
    width="550"
    v-model="opened"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <input
      type="file"
      accept=".pdf"
      style="display: none"
      multiple
      ref="selectedDocuments"
      @change="onDocumentsPicked"
    />

    <v-card flat @drop.prevent="onDocumentsDrop" @dragover.prevent>
      <v-card-title class="py-4 title text-xs-left">
        <h4>Upload Paper-filed Return Packages</h4>
      </v-card-title>

      <v-card-text class="pt-0">
        <v-flex class="hidden-xs-only">
          <v-layout class="drag_and_drop mt-2 mb-3" style="min-height: 180px">
            <v-layout column align-center justify-center>
              <div>
                <v-icon>cloud_upload</v-icon>
              </div>
              <div>
                <span @click="pickDocuments" class=""
                  >Drag and drop the <b>PDF</b> files here or
                  <a href="javascript:void(0)" class="clickable primary--text"
                    >browse</a
                  ></span
                >
              </div>
              <span>(Max Size 150MB)</span>
            </v-layout>
          </v-layout>
        </v-flex>

        <v-layout column>
          <v-layout
            v-for="doc in selectedDocuments"
            :key="doc.name"
            align-center
            justify-space-between
            class="selected_document_item"
          >
            <span>
              {{ doc.name }}
            </span>

            <v-tooltip bottom>
              <v-btn
                slot="activator"
                icon
                flat
                color="error"
                @click="removeDocument(doc.name)"
              >
                <v-icon>
                  remove_circle
                </v-icon>
              </v-btn>
              <span>Remove</span>
            </v-tooltip>
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer class="hidden-xs-only" />

        <v-btn
          class="default-input primary text-capitalize"
          @click="$emit('upload-documents', selectedDocuments)"
          :disabled="isEmpty(selectedDocuments)"
          :loading="uploading"
        >
          Upload
        </v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          outline
          class="default-input error--text text-capitalize"
          @click="$emit('update:opened', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    uploading: {
      type: Boolean,
    },
  },

  data() {
    return {
      selectedDocuments: [],
    };
  },

  methods: {
    isEmpty,

    pickDocuments() {
      const input = this.$refs.selectedDocuments;
      input.type = 'text';
      input.type = 'file';
      this.$refs.selectedDocuments.click();
    },

    onDocumentsPicked(e) {
      const documents = e.target.files;

      if (documents) {
        this.selectedDocuments.push(...documents);
      }
    },

    onDocumentsDrop(e) {
      e.preventDefault();
      const documents = e.dataTransfer.files;

      if (documents) {
        this.selectedDocuments.push(...documents);
      }
    },

    removeDocument(docName) {
      this.selectedDocuments = this.selectedDocuments.filter(
        doc => doc.name !== docName,
      );
    },
  },

  watch: {
    opened() {
      if (!this.opened) {
        this.selectedDocuments = [];
      }
    },
  },
};
</script>

<style scoped>
.drag_and_drop {
  border: 1px solid #ccc;
  background-color: #f7f7f7;
  border-radius: 4px;
}

.selected_document_item {
  border-bottom: 1px solid #ddd;
}
</style>
